module.exports = __webpack_public_path__ + "img/odometer.0a4636bf.svg";